import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import Select from "react-select";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import DownloadExcel from "utils/DownloadExcel";
import { isOverDue, pageSizeOptions } from "utils/HelperFunction";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import useInitQoDataList from "hooks/quotation/useInitQoDataList";
import moment from "moment";
import QoDocStatus from "layouts/QoDocStatus";
import { NumericFormat } from "react-number-format";
import { isShowBranch } from "utils/HelperMemberFunction";
export function QuotationList() {
    var _useInitQoDataList = useInitQoDataList({
        initStatus: null
    }), pageModel = _useInitQoDataList.pageModel, setPageModel = _useInitQoDataList.setPageModel, filterText = _useInitQoDataList.filterText, setFilterText = _useInitQoDataList.setFilterText, data = _useInitQoDataList.data, setData = _useInitQoDataList.setData, btnempstatus = _useInitQoDataList.btnempstatus, setBtnempstatus = _useInitQoDataList.setBtnempstatus, getData = _useInitQoDataList.getData, isMemoLoading = _useInitQoDataList.isMemoLoading, qoStatusCount = _useInitQoDataList.qoStatusCount;
    var columnsd = [
        {
            field: "doc_number",
            headerName: "เลขที่ใบเสนอราคา",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("a", {
                    className: "tc-9",
                    href: "/sale/quotation/edit/".concat(row.id),
                    target: "_blank",
                    children: row.doc_number
                });
            }
        },
        {
            field: "full_member_name",
            headerName: "ชื่อลูกค้า",
            width: 250,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var isShowBranchMember = isShowBranch({
                    custType: row.member_customer_type,
                    isHQ: row.member_is_hq,
                    branchNo: row.member_branch_no
                });
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.full_member_name,
                        isShowBranchMember && /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx("br", {}),
                                "(",
                                row.member_is_hq ? "สำนักงานใหญ่" : row.member_branch_no,
                                ")"
                            ]
                        })
                    ]
                });
            }
        },
        {
            field: "customerGroupName",
            headerName: "กลุ่มลูกค้า",
            width: 160,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: "-"
                });
            }
        },
        {
            field: "doc_issue_date",
            headerName: "วันที่ออกเอกสาร",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_issue_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "doc_expire_date",
            headerName: "วันที่เอกสารหมดอายุ",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: moment(row.doc_expire_date).format("DD/MM/YYYY")
                });
            }
        },
        {
            field: "dim_mst_payment_type_id",
            headerName: "เงื่อนไขชำระเงิน",
            sortable: false,
            width: 160,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    children: row.dimMstPaymentType.name
                });
            }
        },
        {
            field: "sum_item_quantity",
            headerName: "จำนวนสินค้า",
            width: 110,
            sortable: false
        },
        {
            field: "grand_total_price",
            headerName: "มูลค่าสุทธิ",
            width: 110,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                return /*#__PURE__*/ _jsx("div", {
                    className: "pe-3",
                    children: /*#__PURE__*/ _jsx(NumericFormat, {
                        displayType: "text",
                        thousandSeparator: ",",
                        decimalScale: 2,
                        fixedDecimalScale: true,
                        value: row.grand_total_price
                    })
                });
            }
        },
        {
            field: "dim_mst_qo_status_id",
            headerName: "สถานะ",
            width: 150,
            sortable: false,
            renderCell: function(param) {
                var row = param.row;
                var isDateOverDue = isOverDue(row.doc_expire_date);
                var statusID = isDateOverDue && row.dim_mst_qo_status_id === 2 ? "overdue" : row.dim_mst_qo_status_id;
                var statusName = isDateOverDue && row.dim_mst_qo_status_id === 2 ? "หมดอายุ" : row.dimMstQoStatus.name;
                return /*#__PURE__*/ _jsx(QoDocStatus, {
                    statusID: statusID,
                    statusName: statusName
                }, "qo-status-".concat(row.id));
            }
        }
    ];
    return /*#__PURE__*/ _jsxs("div", {
        className: "qo-page",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2 mb-4",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ขาย"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-2 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "ใบเสนอราคา",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-4 fw-bold tc-2",
                        style: {
                            color: "rgba(76, 78, 100, 0.87)"
                        },
                        children: "ใบเสนอราคา"
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == null ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(null);
                                },
                                children: [
                                    "ทั้งหมด",
                                    " "
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                },
                                children: "แบบร่าง"
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 2 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(2);
                                },
                                children: [
                                    "รออนุมัติ(",
                                    qoStatusCount["2"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 3 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(3);
                                },
                                children: [
                                    "อนุมัติแล้ว(",
                                    qoStatusCount["3"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == "overdue" ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus("overdue");
                                },
                                children: [
                                    "หมดอายุ(",
                                    qoStatusCount["overdue"],
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: btnempstatus == 5 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(5);
                                },
                                children: "ยกเลิก"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 pagezoom",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 pt-4 pb-0",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-3 flex-wrap",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-4",
                                    style: {
                                        marginBottom: "12px"
                                    },
                                    children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                        data: data,
                                        filename: "รายชื่อพนักงาน"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-auto",
                                    style: {
                                        width: "220px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3  select-st-1  sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "กลุ่มลูกค้า"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                //   onChange={(e) => {
                                                //     setCustomer(e);
                                                //   }}
                                                className: "w-100 select-st-1",
                                                options: [],
                                                placeholder: "",
                                                value: "",
                                                isDisabled: true
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3 mb-2",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาเลขที่,ชื่อลูกค้า",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/sale/quotation/create",
                                    className: "btn btn btn-st-7 mb-2 px-4",
                                    children: "สร้างใบเสนอราคา"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            sx: {
                                height: "782px",
                                width: "100%"
                            },
                            children: /*#__PURE__*/ _jsx(DataGrid, {
                                loading: isMemoLoading,
                                getRowId: function(row) {
                                    return row.id;
                                },
                                getRowHeight: function() {
                                    return "auto";
                                },
                                rows: data,
                                pagination: true,
                                paginationMode: "server",
                                paginationModel: {
                                    page: pageModel.page - 1,
                                    pageSize: pageModel.pageSize
                                },
                                onPaginationModelChange: function(newPagination) {
                                    setPageModel(function(prev) {
                                        return _object_spread_props(_object_spread({}, prev), {
                                            page: newPagination.page + 1,
                                            pageSize: newPagination.pageSize
                                        });
                                    });
                                    getData({
                                        page: newPagination.page + 1,
                                        limit: newPagination.pageSize,
                                        searchText: filterText || "",
                                        mstNewStatusID: btnempstatus
                                    });
                                },
                                rowsPerPage: pageModel.page,
                                rowCount: pageModel.total,
                                columns: columnsd,
                                pageSizeOptions: pageSizeOptions,
                                checkboxSelection: true,
                                disableRowSelectionOnClick: true,
                                slotProps: {
                                    pagination: {
                                        labelRowsPerPage: "จำนวนรายการต่อหน้า"
                                    }
                                },
                                sx: {
                                    fontFamily: "Sarabun",
                                    fontSize: "18px",
                                    ".MuiDataGrid-columnHeaderTitle": {
                                        fontFamily: "Sarabun",
                                        fontSize: "18px"
                                    }
                                }
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "py-4"
            })
        ]
    });
}
